import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetPrestacionModalidadCiclicaByID from "services/record/PrestacionModalidadCiclica/useGetPrestacionModalidadCiclicaByID";
import useGetInfoPrestacionModalidadCiclica from "services/record/PrestacionModalidadCiclica/useGetInfoPrestacionModalidadCiclica";
import useGetPrestacionModalidadCiclicaByUser from "services/record/PrestacionModalidadCiclica/useGetPrestacionModalidadCiclicaByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import PrestacionModalidadCiclica from "./PrestacionModalidadCiclica";

const GridPrestacionModalidadCiclica = ({ expedienteId = null, origen = null }) => {

    const {
        getPrestacionModalidadCiclicaByID,
        loadingGetPrestacionModalidadCiclicaByID,
        statusGetPrestacionModalidadCiclicaByID
    } = useGetPrestacionModalidadCiclicaByID();

    const {
        getInfoPrestacionModalidadCiclica,
        loadingGetInfoPrestacionModalidadCiclica,
        statusGetInfoPrestacionModalidadCiclica
    } = useGetInfoPrestacionModalidadCiclica();

    const {
        dataGetPrestacionModalidadCiclicaByUser,
        getPrestacionModalidadCiclicaByUser,
        loadingGetPrestacionModalidadCiclicaByUser,
        statusGetPrestacionModalidadCiclicaByUser
    } = useGetPrestacionModalidadCiclicaByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Solicitud prestación modalidad cíclica";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getPrestacionModalidadCiclicaByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetPrestacionModalidadCiclicaByID?.status) {
            setCurrentHttp({
                status: statusGetPrestacionModalidadCiclicaByID.status,
                statusText: statusGetPrestacionModalidadCiclicaByID.statusText
            });
        } else if (statusGetInfoPrestacionModalidadCiclica?.status) {
            setCurrentHttp({
                status: statusGetInfoPrestacionModalidadCiclica.status,
                statusText: statusGetInfoPrestacionModalidadCiclica.statusText
            });
        } else if (statusGetPrestacionModalidadCiclicaByUser?.status) {
            setCurrentHttp({
                status: statusGetPrestacionModalidadCiclicaByUser.status,
                statusText: statusGetPrestacionModalidadCiclicaByUser.statusText
            });
        }
    }, [
        statusGetPrestacionModalidadCiclicaByID,
        statusGetInfoPrestacionModalidadCiclica,
        statusGetPrestacionModalidadCiclicaByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getPrestacionModalidadCiclicaByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoPrestacionModalidadCiclica(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetPrestacionModalidadCiclicaByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetPrestacionModalidadCiclicaByUser]);

    const isLoading = () => {
        return (
            loadingGetPrestacionModalidadCiclicaByID ||
            loadingGetInfoPrestacionModalidadCiclica ||
            (loadingGetPrestacionModalidadCiclicaByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetPrestacionModalidadCiclicaByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <PrestacionModalidadCiclica
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getPrestacionModalidadCiclicaByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridPrestacionModalidadCiclica;

